export const CACHE_KEY_LIST_CAUSE = 'causes';
export const CACHE_KEY_CAUSE = 'cause-one';
export const ROUTE_PATH_CAUSE = '/configuration/causes';
export const TRANSLATION_PREFIX_CAUSE = 'cause';
export const SECURITY_KEY_CAUSE = 'CAUSE';

export const CAUSE_TYPES = {
  'EXPEDIENT': 'EXPEDIENT',
  'PROCEDURE': 'PROCEDURE',
  'TCP_SUSPENSION_OF_ACTIVITIES': 'TCP_SUSPENSION_OF_ACTIVITIES',
  'TCP_CANCELLATION_PROCEDURE': 'TCP_CANCELLATION_PROCEDURE'
};
export const CAUSE_TYPES_ENUM = Object.values(CAUSE_TYPES);

export const CAUSE_TYPES_APPEARANCE = {
  EXPEDIENT: {color: '#17AB70'},
  PROCEDURE: {color: '#965AFF'},
  TCP_SUSPENSION_OF_ACTIVITIES: {color: '#f39113'},
  TCP_CANCELLATION_PROCEDURE: {color: '#c83356'},
};
